import { isKeyOf } from "@shared/lib/obj";
import { DEFAULT_LOCALE, LOCALES_CONFIG } from "./config";
import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IState } from "@store/types";

const sliceName = `locale` as const;

export type LocaleState = {
    locale: string;
};

const getInitialLocale = (): string => {
    if (typeof window === "undefined") return DEFAULT_LOCALE;

    const saved = localStorage.getItem("locale");

    if (saved) return saved;

    return DEFAULT_LOCALE;
};

const initialState: LocaleState = {
    locale: getInitialLocale(),
};

export const localeSlice = createSlice({
    name: sliceName,
    initialState,
    reducers: {
        setLocale: (state, action: PayloadAction<string>) => {
            state.locale = action.payload;

            if (typeof window !== "undefined") {
                localStorage.setItem("locale", action.payload);
            }
        },
    },
});

export const { setLocale } = localeSlice.actions;

export const selectLocale = (state: IState) => localeSlice.selectSlice(state).locale;

export const selectSafeLocale = (state: IState) => {
    const locale = selectLocale(state);

    return isKeyOf(locale, LOCALES_CONFIG) ? locale : DEFAULT_LOCALE;
};

export const selectLocaleConfig = (state: IState) => {
    const locale = selectLocale(state);

    return isKeyOf(locale, LOCALES_CONFIG) ? LOCALES_CONFIG[locale] : null;
};

export const selectIsRtl = (state: IState) => selectLocaleConfig(state)?.rtl ?? false;
